<template>
  <div>
    <v-dialog persistent v-model="showGeneratedKeysDialog" width="640">
      <div class="ec-dialog">
        <div class="ec-dialog__header">
          <h2 class="ec-dialog__title">
            Generated Licence Keys
            <span class="gl-licence-name">{{ licenceName }}</span>
          </h2>
          <button class="ec-icon-btn" @click="closeGeneratedLicenceKeysDialog">
            <v-icon size="18">mdi-close</v-icon>
          </button>
        </div>
        <div class="ec-dialog__body" style="padding:0">
          <v-data-table :headers="headersFeature" :items="generatedLicenceKeys" class="ec-table">
            <template v-slot:[`item.label`]="{ item }">
              <span>{{ item.feature_name }}</span>
            </template>

            <template v-slot:[`item.is_generated`]="{ item }">
              <span v-if="item.is_generated" class="u-status-pill u-pill--gray">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on">Assigned</span>
                  </template>
                  <span>This licence is already assigned to a device</span>
                </v-tooltip>
              </span>
              <span v-else class="u-status-pill u-pill--green">Assignable</span>
            </template>

            <template v-slot:[`item.assigned_device`]="{ item }">
              <span v-if="item.assigned_device.device_label">{{ item.assigned_device.device_label }}</span>
              <v-tooltip v-else bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-bind="attrs" v-on="on" color="grey lighten-1">mdi-minus</v-icon>
                </template>
                <span>License doesn't assigned to a device yet.</span>
              </v-tooltip>
            </template>

            <template v-slot:[`item.data_usage`]="{ item }">
              <span v-if="item.data_usage.length > 0" class="u-status-pill u-pill--amber">
                {{ item.data_usage[0].current_data_usages }} / {{ item.data_usage[0].total_limits.data_usage_limits }} GB
              </span>
              <v-tooltip v-else bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-bind="attrs" v-on="on" color="grey lighten-1">mdi-minus</v-icon>
                </template>
                <span>License doesn't assigned to a device yet.</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </div>
      </div>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    generatedLicenceKeys: { type: Array, default: () => [] },
    showGeneratedKeysDialog: { type: Boolean, default: false },
    licenceName: { type: String, default: '' }
  },
  data () {
    return {
      headersFeature: [
        { text: 'ID', value: 'id', align: 'left' },
        { text: 'Status', value: 'is_generated', align: 'center' },
        { text: 'Device Name', value: 'assigned_device', align: 'center' },
        { text: 'User Licence Id', value: 'user_licence_id', align: 'center' },
        { text: 'Data Usage', value: 'data_usage', align: 'center' }
      ]
    }
  },
  methods: {
    closeGeneratedLicenceKeysDialog () {
      this.$emit('closeGeneratedKeysDialog')
    }
  }
}
</script>

<style scoped>
.gl-licence-name {
  font-size: .8rem;
  font-weight: 500;
  color: var(--ec-primary);
  margin-left: 8px;
  padding: 2px 8px;
  background: var(--ec-primary-bg);
  border-radius: 20px;
}

/* Table → global .ec-table in admin.css */
</style>
